import qs from "qs";
import jwt from "jsonwebtoken";
import Axios from "axios";
import { isBrowser } from ".";

let Cohere = null
/**
 * https://app.cohere.so/dashboard
 */
if (isBrowser) {
  Cohere = require('cohere-js')
}

export const IFRAME_ID = "_authing_check_login_iframe";

let idToken = null;
let user = null;

const getIframe = () => {
  if (document.querySelector(`#${IFRAME_ID}`)) {
    return document.querySelector(`#${IFRAME_ID}`);
  }

  const { consoleHost, appId } = window._AUTHING__GLOBAL_CONFIG_;

  const iframe = document.createElement("iframe");
  iframe.id = IFRAME_ID;
  iframe.style.display = "none";
  iframe.src = `${consoleHost}/oidc/auth?${qs.stringify({
    app_id: appId,
    client_id: appId,
    redirect_uri: `${consoleHost}/console/userpool/frontend/callback`,
    response_type: "id_token",
    state: +new Date(),
    nonce: +new Date(),
    scope: "openid profile phone email",
    prompt: "none",
  })}`;
  document.body.append(iframe);

  return iframe;
};

export const getUser = () => {
  return new Promise((resolve) => {
    if (user) {
      return resolve(user);
    }
    getIframe();
    window.addEventListener("message", function handleLogin(evt) {
      try {
        const { event, data } = JSON.parse(evt.data);
        if (event.source === "authing" && ["idTokenFromOidc", "idTokenFromLocalStorage"].includes(event.eventType)) {
          if (data.token) {
            idToken = data.token;
            user = jwt.decode(data.token);
            user.id = user.sub;

            if (Cohere) {
              Cohere.default.identify(
                user.id, // Required: can be any unique ID
                {
                  displayName: user.nickname || user.name || user.email, // Optional
                  email: user.email // Optional
                }
              );
            }
            return resolve(user);
          }

          window.removeEventListener(handleLogin);
        }
      } catch (e) {
        // do nothing
        // console.error('获取用户信息失败', e, evt)
      }
    });
  });
};

export const logout = async () => {
  const iframe = getIframe();
  const { consoleHost, appId } = window._AUTHING__GLOBAL_CONFIG_;

  iframe.contentWindow.postMessage(
    JSON.stringify({
      event: {
        source: "authing",
        eventType: "logout",
      },
    }),
    "*"
  );

  await Axios.get(`${consoleHost}/api/v2/logout?app_id=${appId}`, {
    withCredentials: true,
    headers: {
      "x-authing-app-id": appId,
      Authorization: `Bearer ${idToken}`,
    },
  });

  idToken = null;
  user = null;
};
